import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Box, Button, TextField,  Container,Typography, Alert, Avatar } from '@mui/material';
import axios from 'axios';
import { useNavigate, Link  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/SHeader';
import Footer from '../components/SFooter';
import SupplierJoinPromo from '../components/SupplierJoinPromo';

import PersonIcon from '@mui/icons-material/Person';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const SupplierLogin = () => {
    
    
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    const navigate = useNavigate();
    const { loginSupplier , logoutSupplier, logout } = useAuth();

    
    useEffect(() => {
         logoutSupplier(); 
      logout();
    // Call the onLogout function when the component loads
  //  onLogout();
  }, []);
    
     
      const validatePassword = (value) => {
        let error = '';

        // Rule 1: At least 8 characters
        if (value.length < 8) {
            error = 'Password must be at least 8 characters long.';
          setErrorMessage(error);
          return false;
        } 
        
        // Rule 2: Contain at least one number
        else if (!/.*[0-9].*/.test(value)) {
            error = 'Password must contain at least one number.';
          setErrorMessage(error);
          return false;
        }
        
        // Rule 3: Contain at least one lowercase character (a-z)
        else if (!/.*[a-z].*/.test(value)) {
            error = 'Password must contain at least one lowercase letter (a-z).';
          setErrorMessage(error);
          return false;
        }

        return true;
       
    };
    
const handleLogin = (e) => {
    e.preventDefault();
      if(!validatePassword(password)){ 
    return;
  }
    setErrorMessage(''); 
  

       console.log('Email:', email );
               const newUser = {
              email: email,
              password: password,
               wouldBePartner: 1    
            };
      
     //  
  //  axios.post(`${backendUrl}/api/auth/login`, { email, password })
       axios.post(`${backendUrl}/api/users/login`, newUser)
        .then((response) => {
          const user = response.data;
             localStorage.setItem('token', user.token);
           console.log(user);
      if (user.active)  {
          // Redirect to dashboard if user exists
             console.log('Email:', response.data.userId);
            const userId = response.data.userId;
          
        if(user.wouldBePartner==0){
                setErrorMessage('you already registed the email as customer. Please user customer login page.');
            user.wouldBePartner=1;
          }
          if(user.authorized){
              loginSupplier(user); 
           navigate('/supplierdashboard');
             }else{
                 if(user.provider){
                     console.log("you already registed using the SSO. Please login using SSO");
                     // Catch and handle errors
                     setErrorMessage('you already registed using the SSO. Please login using SSO.');
      
                 }else{
                     console.log("Please enter the correct password");
                     setErrorMessage('Please enter the correct password.');
                 }
             }
                
        } else {
            
            console.log(" u provider "+ user.provider );
               loginSupplier(user); 
          // If user doesn't exist, navigate to user details and pass email & password
          navigate('/supplier-details');
        }
        }).catch(err => {
            console.error('Login failed', err);
           setErrorMessage('An error occurred during login. Please try again.');
        });
};
    
    

    

return (
    
  <>
  <Header />
    
          <div>
   <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        justifyContent: 'center',
        padding: 3,
      }}
    >

      {/* --- 1. The Profile Image (Avatar) --- */}
          {/* MUI Avatar automatically makes the image round */}
          <Avatar
            alt="User Profile"
            src={require('../images/fssupplier.jpeg')}
            sx={{
              width: 100,  // Set desired width
              height: 100, // Set desired height (keep equal for circle)
              marginBottom: 2, // Spacing between image and title
              bgcolor: 'primary.main', // Fallback background color if image fails
              border: '2px solid #eee' // Optional border
            }}
          >
            {/* Fallback icon if src fails to load */}
            <PersonIcon sx={{ fontSize: 40 }} />
          </Avatar>

 {/* Error Message Display */}
        {errorMessage && (
          <Alert severity="error" style={{ marginBottom: '20px' }}>
            {errorMessage}
          </Alert>
        )}

      {/* Divider Text */}
      <Typography variant="h6" sx={{ my: 2 }}>
        Supplier Login with Email/Password
      </Typography>
  

      {/* Email/Password Login Form */}
      <form onSubmit={handleLogin} style={{ width: '100%', maxWidth: '400px' }}>
        {/* Email Input */}
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Password Input */}
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Submit Button */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          sx={{ marginBottom: 4 }}
        >
          Login with Email/Password
        </Button>
      </form>
  <Typography>By login/registering, you agree to our
            <Link to="/terms">Terms and Conditions</Link> and  <Link to="/privacypolicy">Privacy Policy</Link>
             </Typography>
 {/* Forgot Password Link */}
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <Link to="/forgot-password" style={{ textDecoration: 'none', color: '#3f51b5' }}>
            Forgot Password?
          </Link>
        </div>


</Container>
      </div>
<SupplierJoinPromo />
  <Footer />
    </>
);
};

export default SupplierLogin;
